import React from "react";
import { Button, MenuItem, Select, FormControl, InputLabel, TextField } from "@mui/material";

const allowedDeviceTypes = [
  "VEHICLE_TRACKING",
  "SMART_METER",
  "ASSET_TRACKING",
  "POS_MACHINE",
  "HOME_AUTOMATION",
  "INDUSTRIAL_AUTOMATION",
  "SURVEILLANCE",
  "PERSONAL_TRACKER",
  "TRAFFIC_MANAGEMENT",
  "OTHERS",
];

const DeviceTypePopup = ({
  open,
  onClose,
  tempDeviceTypeValue,
  setTempDeviceTypeValue,
  tempDeviceModelValue,
  setTempDeviceModelValue,
  deviceTypeValue,
  deviceModelValue,
  handleCloseDeviceTypePopup,
  handleConfirmDeviceType,
}) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
          width: "400px",
          maxWidth: "90%",
        }}
      >
        <div
          style={{
            backgroundColor: "var(--bg)",
            color: "white",
            padding: "1rem 2rem",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            fontWeight: "bold",
            fontSize: "1.25rem",
            textAlign: "center",
          }}
        >
          Set Device Type & Model
        </div>

        <div style={{ padding: "2rem", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <FormControl fullWidth>
            <InputLabel>Device Type</InputLabel>
            <Select
              value={tempDeviceTypeValue}
              onChange={(e) => setTempDeviceTypeValue(e.target.value)}
              label="Device Type"
              MenuProps={{
                disablePortal: true,
                PaperProps: {
                  style: {
                    zIndex: 15000,
                  },
                },
              }}
            >
              {allowedDeviceTypes.map((type) => (
                <MenuItem key={type} value={type}>
                  {type.replace(/_/g, " ")}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Device Model"
            value={tempDeviceModelValue}
            onChange={(e) => setTempDeviceModelValue(e.target.value)}
            placeholder="Enter device model (optional)"
            variant="outlined"
          />

          {(deviceTypeValue || deviceModelValue) && (
            <div
              style={{
                padding: "0.75rem",
                backgroundColor: "#e7f3ff",
                borderRadius: "4px",
                fontSize: "0.9rem",
                color: "#4151e0",
                border: "1px solid #4151e0",
              }}
            >
              {deviceTypeValue && (
                <div>
                  Current Device Type: <strong>{deviceTypeValue}</strong>
                </div>
              )}
              {deviceModelValue && (
                <div style={{ marginTop: deviceTypeValue ? "0.25rem" : 0 }}>
                  Current Device Model: <strong>{deviceModelValue}</strong>
                </div>
              )}
            </div>
          )}
        </div>

        <div
          style={{
            padding: "1rem 2rem 2rem",
            display: "flex",
            gap: "1rem",
            justifyContent: "flex-end",
          }}
        >
          <Button variant="outlined" onClick={handleCloseDeviceTypePopup}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmDeviceType}
            disabled={!tempDeviceTypeValue && !tempDeviceModelValue}
            style={{
              backgroundColor: "#4151e0",
              color: "white",
            }}
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeviceTypePopup;